import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Löschen', 
  cancelText = 'Abbrechen',
  type = 'danger' // danger, warning, info
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const modalStyles = {
    danger: {
      confirmBg: '#dc2626',
      confirmHover: '#b91c1c',
      border: '1px solid #dc2626'
    },
    warning: {
      confirmBg: '#f59e0b', 
      confirmHover: '#d97706',
      border: '1px solid #f59e0b'
    },
    info: {
      confirmBg: '#6366f1',
      confirmHover: '#4c51bf', 
      border: '1px solid #6366f1'
    }
  };

  const style = modalStyles[type];

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '1rem'
      }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 150, damping: 20 }}
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'var(--color-surface-elevated)',
          borderRadius: 'var(--border-radius-large)',
          padding: '2rem',
          maxWidth: '400px',
          width: '100%',
          border: style.border,
          boxShadow: 'var(--shadow-xl)',
          color: 'var(--color-text-primary)',
          fontFamily: 'var(--font-display)'
        }}
      >
        <h3 style={{
          margin: '0 0 1rem 0',
          fontSize: '1.5rem',
          fontWeight: '700',
          color: 'var(--color-accent)'
        }}>
          {title}
        </h3>
        
        <p style={{
          margin: '0 0 2rem 0',
          fontSize: '1rem',
          lineHeight: '1.5',
          color: 'var(--color-text-secondary)'
        }}>
          {message}
        </p>

        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end'
        }}>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClose}
            style={{
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              fontWeight: '600',
              backgroundColor: 'var(--color-surface)',
              color: 'var(--color-text-primary)',
              border: '1px solid var(--color-accent-dim)',
              borderRadius: 'var(--border-radius-medium)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          >
            {cancelText}
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onConfirm}
            style={{
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              fontWeight: '600',
              backgroundColor: style.confirmBg,
              color: 'white',
              border: 'none',
              borderRadius: 'var(--border-radius-medium)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = style.confirmHover;
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = style.confirmBg;
            }}
          >
            {confirmText}
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default ConfirmModal;
